<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2 13L8 13L14 13"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />

  <path
    d="M5 6L8 3L11 6"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M8 10L8 3"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
